import ColumnTemplate from '@vindr/ui/src/components/Templates/columns/columnRenderTemplates';
import { useGetOrders } from '@vindr/services/actions/order.action';
import { STATUS_COLOR } from '@vindr/services/constants/common.constant';
import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { DefinedColumns } from '@vindr/services/interfaces';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

interface OrderColumnsType
  extends DefinedColumns<ReturnType<typeof useGetOrders>['data']['data'][number]> {}

const useDefinedColumns = ({ pagination }): OrderColumnsType[] => {
  const { t } = useTranslation('Vindoc');

  return [
    ColumnTemplate.Index({ pagination }),
    {
      title: t('Status'),
      width: 70,
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      render: (status) => (
        <Tag
          color={STATUS_COLOR[ORDER_STATUS[status]]}
          className="flex w-full justify-center align-middle"
        >
          {t(ORDER_STATUS[status])}
        </Tag>
      ),
    },
    {
      title: t('Order Group'),
      dataIndex: 'order_group',
      key: 'order_group',
      width: 110,
      ellipsis: true,
    },
    {
      title: t('Patient ID'),
      width: 110,
      dataIndex: ['visited_patient', 'patient_id'],
      key: 'visited_patient_id',
      ellipsis: true,
    },
    // {
    //   title: t('Visit ID'),
    //   width: 100,
    //   dataIndex: ['visited_patient', 'visit_id'],
    //   key: 'visited_patient.visit_id',
    //   ellipsis: true,
    // },
    {
      title: t('Patient Name'),
      width: 200,
      dataIndex: ['visited_patient', 'name'],
      key: 'visited_patient.name',
      ellipsis: true,
    },
    /* {
      title: t('Age'),
      dataIndex: ['visited_patient', 'age'],
      key: 'visited_patient.age',
      width: 52,
      align: 'center',
    }, */
    // {
    //   title: t('Institution'),
    //   dataIndex: ['institution', 'name'],
    //   key: 'institution.name',
    //   width: 180,
    //   ellipsis: true,
    // },
    {
      title: t('Scheduled Date'),
      dataIndex: 'scheduled_date',
      key: 'scheduled_date',
      width: 140,
      sorter: true,
      ellipsis: true,
      defaultSortOrder: 'descend',
      render: (date) => formatDateColumn(date),
    },
    {
      title: t('Study Description'),
      dataIndex: ['procedure', 'compact_name'],
      key: 'study_desc',
      width: 300,
      ellipsis: true,
    },
    {
      title: t('Modality'),
      dataIndex: ['procedure', 'modality'],
      key: 'modality',
      width: 80,
    },
    {
      title: t('Device'),
      dataIndex: ['device', 'name'],
      key: 'device.name',
      width: 100,
      ellipsis: true,
    },
    {
      title: t('Arrived At'),
      dataIndex: 'patient_arrived_time',
      key: 'patient_arrived_time',
      width: 140,
      sorter: true,
      ellipsis: true,
      render: (date) => formatDateColumn(date),
    },
    {
      title: t('Ordinal Number'),
      dataIndex: 'ordinal_number',
      key: 'ordinal_number',
      width: 110,
      ellipsis: true,
    },
    // {
    //   title: t('Actions'),
    //   dataIndex: 'operation',
    //   key: 'operation',
    //   align: 'center',
    //   width: 120,
    //   render: (text, record) => {
    //     return (
    //       <ActionIcon>
    //         <ActionIcon.Assign
    //           onClick={() => onAssign(record)}
    //           disabled={
    //             !keycloak.hasOneOfPerm([PERMISSIONS.order.assign]) ||
    //             [ORDER_STATUS.NEW, ORDER_STATUS.ARRIVED, ORDER_STATUS.CANCEL].includes(
    //               record.status
    //             )
    //           }
    //         />
    //         <ActionIcon.Edit
    //           onClick={() => onEdit(record)}
    //           disabled={!keycloak.hasOneOfPerm([PERMISSIONS.order.update])}
    //         />
    //         <ActionIcon.Delete
    //           onClick={() => onRemove(record)}
    //           disabled={!keycloak.hasOneOfPerm([PERMISSIONS.order.delete])}
    //         />
    //       </ActionIcon>
    //     );
    //   },
    // },
  ];
};

export default useDefinedColumns;
